import { Utils } from './module/utils';

// -----------------------------------------------
// URLパラメーターにより表示するタブを切り替える
// -----------------------------------------------
function initTabFromURLParameter() {

  // URLからクエリパラメータを取得
  const params = new URLSearchParams(window.location.search);
  
  const tab = params.get('tab');
  if (tab) {
    openTab(tab);
  }
  
  const hash = window.location.hash;
  if (hash) {
    window.location.hash = hash;
  }
}

// -----------------------------------------------
// 指定idのタブを開く
// -----------------------------------------------
function openTab(tabId) {
  // すべてのタブを非表示にする
  const tabItems = document.querySelectorAll('.js-tabItem');
  const tabContents = document.querySelectorAll('.js-tabContent');

  tabItems.forEach((tabItem) => tabItem.classList.remove('is-active'));
  tabContents.forEach((tabContent) => tabContent.classList.remove('is-active'));


  // 指定されたタブを表示する
  const targetTab = document.getElementById(tabId);
  
  if (targetTab) {
    targetTab.classList.add('is-active');
    const tabIndex = findTabIndex(tabItems, tabId);
    tabContents[tabIndex].classList.add('is-active');
  }
}

function findTabIndex(tabItems, tabId) {
  let index = -1;

  tabItems.forEach((tabItem, i) => {
    if (tabItem.id === tabId) {
      index = i;
    }
  });

  return index; // 0から始まるインデックス、または-1（見つからない場合）
}

// -----------------------------------------------
// 初回表示の場合Trueを返却する
// -----------------------------------------------
function isFirstVisit() {
  const hasVisited = sessionStorage.getItem("hasVisited");
  if (!hasVisited) {
    sessionStorage.setItem("hasVisited", "true");
    return true;
  }
  return false;
}

// -----------------------------------------------
// スクロールアニメーション定義
// -----------------------------------------------
// ふわっと上がる
const fadeInUp = {
  set: { y: '60px', opacity: 0 },
  to: { y: '0', opacity: 1, duration: 0.8, delay: 0, ease: 'power3.easeIn' },
};
// 上からふわっと
const fadeInDown = {
  set: { y: '-60px', opacity: 0 },
  to: { y: '0', opacity: 1, duration: 0.8, delay: 0, ease: 'power3.easeIn' },
};
// スライド右→左
const slideRL = {
  set: { x: '100%', opacity: 0 },
  to: { x: '0%', opacity: 1, duration: 1.5, delay: 0, ease: 'power1.easeIn' },
};
// スライド左→右
const slideLR = {
  set: { x: '-100%', opacity: 0 },
  to: { x: '0%', opacity: 1, duration: 1.5, delay: 0, ease: 'power1.easeIn' },
};
// ランダムフェードイン
const fadeInRandom = {
  set: { target: '.js-scroll-anime-target', opacity: 0, scale: 1.05, filter: 'blur(25px)' },
  to: { target: '.js-scroll-anime-target', opacity: 1, scale: 1, filter: 'blur(0px)', duration: 0.9, ease: 'power2.easeIn', stagger: { from: 'random', amount: 0.6 }},
};
//順にフェードイン
const fadeInOrder = {
  set: { target: '.js-scroll-anime-target', opacity: 0 },
  to: { target: '.js-scroll-anime-target', opacity: 1, duration: 1.2, ease: 'power2.easeIn', stagger: { from: 'start', amount: 0.8 }},
};


// アニメーション定義
const animationConfig = {
  fadeInUp,
  fadeInDown,
  slideRL,
  slideLR,
  fadeInRandom,
  fadeInOrder,
};

// -----------------------------------------------
// スクロールアニメーション初期化
// -----------------------------------------------
function initScrollAnimation(selector, options = { once: true }) {
  const isInitialVisit = isFirstVisit();
  const targets = document.querySelectorAll(selector);

  targets.forEach((el) => {
    const anime = JSON.parse(JSON.stringify(animationConfig[el.dataset.anime]));

    // 初回訪問以外で、data-initial-animate属性がある要素のアニメーションはスキップ
    if (!isInitialVisit && el.hasAttribute('data-initial-animate')) {
      return;
    }

    // 初回訪問時のみ、data-initial-delayを適用
    if (isInitialVisit && el.hasAttribute('data-initial-delay')) {
      anime.to.delay = parseFloat(el.getAttribute('data-initial-delay'));
    }

    // -------------------------
    // set（初期設定）
    // -------------------------
    // setが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.set)) {
      anime.set = new Array(anime.set);
    }
    anime.set.forEach((set) => {
      let target = el;
      if (set.target) {
        target = set.target;
        delete set.target;
      }
      gsap.set(target, set);
    });

    // -------------------------
    // to（アニメーション）
    // -------------------------
    // toが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.to)) {
      anime.to = new Array(anime.to);
    }

    // scrollTrigger設定
    let st = { scrollTrigger: { trigger: el, start: 'top+=150 bottom+=100' } };
    if (el.dataset.start) {
      st.scrollTrigger.start = el.dataset.start;
    }

    // let st = { scrollTrigger: { trigger: el, markers: true, start: 'top+=50 bottom' } };
    if (!options.once) {
      st.scrollTrigger.toggleActions = 'play reset play reset';
    }

    const tl = gsap.timeline(st);
    anime.to.forEach((to, index) => {
      // 配列の先頭要素だけ、data属性から渡された時間を設定する
      if (index === 0) {
        // data属性 > 定数 の優先度でセットする。全てなしならば0とする
        to.duration = el.dataset.duration || to.duration || 0;
        to.delay = el.dataset.delay || to.delay || 0;
      }

      let target = el;
      if (to.target) {
        target = target.querySelectorAll(to.target);
        delete to.target;
      }
      if (to.position || to.position === 0) {
        const position = to.position;
        delete to.position;
        tl.to(target, to, position);
        console.log(position);
      } else {
        tl.to(target, to);
      }
    });
  });
}


//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {

  // URLパラメーターにより表示するタブを切り替える
  initTabFromURLParameter();

  // アコーディオンクリック
  if (document.querySelector('.js-accordion .js-accordion-button')) {
    document.querySelectorAll('.js-accordion .js-accordion-button').forEach((el) => {
      el.addEventListener('click', (event) => {

        // クリックされた要素がaタグだったら何もしないで抜ける
        if (event.target.tagName.toLowerCase() === 'a') {
          return true;
        }  

        event.preventDefault();
        event.target.classList.toggle('is-open');
        const target = event.target.querySelector('.js-accordion-target');
        jQuery(target).slideToggle(500);

        // アコーディオンの開閉で高さが変化するので、トリガー位置をリフレッシュする
        // (アコーディオン動作を待ってから処理する)
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 500);
      });
    });
  }

  // スクロールアニメーション
  if (document.querySelector('.js-scroll-anime')) {
    initScrollAnimation('.js-scroll-anime');
  }
});


// /*
//  ** 【編集可能】
//  ** デバイスサイズ情報
//  **
//  ** name:       画面の大きさの名前
//  ** minSize:    画面幅の最小値（単位px）
//  ** maxSize:    画面幅の最大値（単位px）
//  ** column:     表示する列の数
//  **
//  */
//  const deviceSizeInfo = [
//   { name: 'large pc', minSize: 1025, maxSize: 99999, column: 4 },
//   { name: 'pc', minSize: 769, maxSize: 1024, column: 2 },
//   { name: 'tablet', minSize: 426, maxSize: 768, column: 2 },
//   { name: 'sp', minSize: 0, maxSize: 425, column: 2 },
// ];

// /*
//  ** 【編集可能】
//  ** ギャラリー画像情報
//  **
//  ** galleryFolder:   ギャラリーフォルダパス
//  ** groupFolder:    グループフォルダ名
//  ** categoryFolder:  カテゴリ（タブ）フォルダ名
//  ** imageFile:       画像ファイル名
//  ** initialDisplayDefault:  初回時表示する画像の枚数
//  ** groups:  グループ情報
//  **   no:         番号
//  **   name:       グループ名
//  **   category:   カテゴリ（タブ）数
//  **   imageCount: カテゴリ毎の画像数 ※配列で指定する
//  **
//  */
// const galleryImageInfo = {
//   // galleryFolder: './assets/img/08_gallery',
//   galleryFolder: '../wp-content/themes/tuzuno/assets/img/08_gallery',
//   groupFolder: 'group',
//   categoryFolder: 'category',
//   imageFile: 'image.jpg',
//   initialDisplayDefault: 8,
//   groups: [
//     { no: '1', name: '平和島本店', category: 5, categoryName: ['エントランス受付', '2階相談コーナー', '1階相談コーナー', '調剤室', '外観', '' ], imageCount: [12, 9, 5, 21, 7] },
//     { no: '2', name: '田町店', category: 5, categoryName: ['エントランス受付', '2階相談コーナー', '1階相談コーナー', '調剤室', '外観', '' ], imageCount: [5, 3, 9, 4, 4] },
//     { no: '3', name: 'お取扱漢方商品', category: 6, categoryName: ['イスクラ産業', '湧永製薬', 'ベネセーレ', '準備中', '準備中', 'その他' ], imageCount: [6, 4, 4, 4, 4, 4] },
//   ],
// };

// // ギャラリー画像HTMLを追加する
// function appendGalleryHtml(galleryImageInfo) {
//   // ウィンドウサイズからデバイス幅情報を取得する
//   const deviceWidth = deviceSizeInfo.find((device) => {
//     return (device.minSize <= window.innerWidth && window.innerWidth <= device.maxSize);
//   });

//   // 店舗数分ループする
//   galleryImageInfo.groups.forEach((group) => {
//     appendGalleryCategoryHtml(group, deviceWidth, galleryImageInfo);
//   });
// }

// // ギャラリーカテゴリー画像のHTMLを追加する
// function appendGalleryCategoryHtml(group, deviceWidth, galleryImageInfo) {

//   // Galleryカテゴリ数分ループ
//   for (let iCate = 0; iCate < group.category; iCate++) {

//     // 該当のカテゴリフォルダパスを取得
//     const galleryFolder = galleryImageInfo.galleryFolder;
//     const groupFolder = `${String(group.no).padStart(2, 0)}_${galleryImageInfo.groupFolder}`;
//     const categoryNo = iCate + 1;
//     const categoryFolder = `${String(categoryNo).padStart(2, 0)}_${galleryImageInfo.categoryFolder}`;

//     // HTMLを挿入する要素を取得
//     const insertElementId = `gallery-group-${group.no}_category-${categoryNo}`;
//     const insertElement = document.querySelector('#' + insertElementId + ' .gallery-group__flexbox');

//     // 挿入HTML、カテゴリ毎の画像数を初期化
//     let insertHtml = ''; 
//     const imageCount = group.imageCount[iCate];
//     if (imageCount === 0) continue;

//     // Gallery画像列数分ループ
//     for (let iColumn = 0; iColumn < deviceWidth.column; iColumn++) {

//       insertHtml += `<div class="gallery-group__image-column">`;

//       // Gallery画像数分ループ
//       const initialDisplayCount = galleryImageInfo.initialDisplayDefault / deviceWidth.column;
//       for (let iImage = iColumn, index = 0; iImage < imageCount; iImage += deviceWidth.column, index++) {
        
//         // 初期表示数を超えたら非表示にする
//         const hiddenClass = index < initialDisplayCount ? '' : 'utils-hidden';

//         // 画像URLを取得
//         const imageNoString = String(iImage + 1).padStart(2, 0);
//         const imageFile = galleryImageInfo.imageFile;
//         const imageSrc = `${galleryFolder}/${groupFolder}/${categoryFolder}/${imageNoString}_${imageFile}`;
//         const paddedIndex = String(iImage + 1).padStart(2, '0');
//         const imageAlt = `${group.name}${group.categoryName[iCate]}の写真${paddedIndex}`;

//         insertHtml += `
//               <figure class="gallery-group__image ${hiddenClass}">
//                   <img src="${imageSrc}" alt="${imageAlt}" decoding="async">
//               </figure>
//           `;
//       }
//       insertHtml += `</div>`;
//     }
//     // HTMLの挿入 (表示)
//     insertElement.innerHTML = insertHtml;
//   }
// }

// function playClickSeemoreAnime(targets) {
//   const tl = gsap.timeline();
//   tl.to(targets, { display: 'block', opacity: 1, duration: 1, stagger: { from: 'start', amount: 0.5 } });

// }

// let this_window_width = 0;
// (function initGalleryEvent() {
//   // DOMロード時のイベント処理
//   document.addEventListener('DOMContentLoaded', () => {
//     appendGalleryHtml(galleryImageInfo);

//     this_window_width = window.innerWidth;
//   });

//   // 画面リサイズのイベント処理
//   window.addEventListener('resize', () => {
//     // 変更後の画面サイズ
//     const new_window_width = window.innerWidth;

//     // 画面の横幅だけ変わったら実行
//     if (new_window_width != this_window_width) {
//       this_window_width = new_window_width;

//       appendGalleryHtml(galleryImageInfo);
//     }
//   });
//   this_window_width = window.innerWidth;

//   // See Moreボタンクリック時のイベント処理
//   const els = document.querySelectorAll('.gallery-group__category .js-seemore-button');
//   els.forEach( el => {
//     el.addEventListener('click', event => {
      
//       // クリックされたSee Moreボタンのidから、画像のidを取得する
//       let id = event.target.getAttribute('id');
//       id = id.replace('seemore_', '');

//       // ボタンを非表示にし、全ての画像を表示する 
//       event.target.classList.add('utils-hidden');
//       const targets = document.querySelectorAll('#' + id + ' .gallery-group__image.utils-hidden');

//       if (targets.length === 0) return;

//       const tl = gsap.timeline();
//       tl.set(targets, { opacity: 0 });
//       tl.add(() => targets.forEach((target) => target.classList.remove('utils-hidden')));
//       tl.to(targets, { display: 'block', opacity: 1, duration: 1, stagger: { from: 'start', amount: 0.5 } });
//     });  
//   });  
// }());
